import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import BaseTableNew from 'components/atoms/base-table/new';
import { useAppDispatch, useAppSelector } from 'store';

import { useColumns } from './columns';
import { Row } from './table-row';
import s from './styles.module.scss';

import type { IQueueTableData } from 'infrastructure/interfaces';
import type { FC } from 'react';
import type { DragEndEvent } from '@dnd-kit/core';

interface QueueTableProps {}

const genQueueItemKey = (qItem: IQueueTableData) =>
  `${qItem.guid}_${qItem.tableName}`;

const QueueTable: FC<QueueTableProps> = () => {
  const workQueue = useAppSelector((state) => state.ccmConsole.workQueue);
  const {
    ccmConsole: { setWorkQueue },
  } = useAppDispatch();

  const columns = useColumns();

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      const activeIndex = workQueue.findIndex(
        (record) => genQueueItemKey(record) === active?.id,
      );
      const overIndex = workQueue.findIndex(
        (record) => genQueueItemKey(record) === over?.id,
      );
      const newQueueItem = arrayMove(workQueue, activeIndex, overIndex);
      setWorkQueue(newQueueItem);
    }
  };

  return (
    <DndContext onDragEnd={onDragEnd} modifiers={[restrictToVerticalAxis]}>
      <SortableContext
        items={workQueue.map(genQueueItemKey)}
        strategy={verticalListSortingStrategy}
      >
        <BaseTableNew
          rowKey={genQueueItemKey}
          components={{ body: { row: Row } }}
          columns={columns}
          items={workQueue}
          bordered
          loading={false}
          className={s['queue-table']}
          dataCy="queue-table"
        />
      </SortableContext>
    </DndContext>
  );
};
export default QueueTable;
